
export const font = {
//    table_header_text: {
//        height: '18px',
//        color: '#171717',
//        fontFamily: 'Open Sans',
//        fontSize: '14px',
//        fontWeight: '600',
//        letterSpacing: '0.16px',
//        lineHeight: '18px',
//        whiteSpace:'nowrap',
//        padding: '0'
//    },
//    table_cell_text: {
//        height: '18px',
//        color: '#565656',
//        fontFamily: 'Open Sans',
//        fontSize: '14px',
//        letterSpacing: '0.16px',
//        lineHeight: '18px',
//        padding: '0',
//        minWidth: '130px'
//    },
//
//    card_header:{
//        height: '18px',
//        color: '#171717',
//        fontFamily: 'Open Sans',
//        fontSize: '14px',
//        fontWeight: '600',
//        letterSpacing: '0.16px',
//        lineHeight: '18px',
//        whiteSpace:'nowrap',
//        paddingTop: '10px'
//    },
//    card_subheader:{
//        height: '18px',
//        color: '#171717',
//        fontFamily: 'Open Sans',
//        fontSize: '14px',
//        fontWeight: '600',
//        letterSpacing: '0.16px',
//        lineHeight: '18px',
//        whiteSpace:'nowrap',
//        padding: '0'
//    },
//    card_content_text:{
//        height: '18px',
//        color: '#565656',
//        fontFamily: 'Open Sans',
//        fontSize: '14px',
//        letterSpacing: '0.16px',
//        lineHeight: '18px',
//        padding: '0'
//    },
//    card_content_text_center:{
//        height: '18px',
//        color: '#565656',
//        fontFamily: 'Open Sans',
//        fontSize: '14px',
//        letterSpacing: '0.16px',
//        lineHeight: '18px',
//        padding: '0'
//    },
//    tab_label:{
//        height: '18px',
//        color: '#171717',
//        fontFamily: 'Open Sans',
//        fontSize: '14px',
//        fontWeight: '600',
//        letterSpacing: '0.16px',
//        lineHeight: '18px',
//        whiteSpace:'nowrap',
//        padding: '0'
//    },
//
      bar_text: {
          height: '18px',
          color: '#565656',
          fontFamily: 'Open Sans',
          fontSize: '20px',
          fontsizeint: 20,
          letterSpacing: '0.16px',
          lineHeight: '18px',
          padding: '0',
          minWidth: '130px'
      },
//    font_family: {
//        fontFamily: 'Open Sans',
//    }
}


// WEBPACK FOOTER //
// ./src/components/CSS/font.js